var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MglMap',_vm._b({staticClass:"map"},'MglMap',{ ..._vm.$attrs, ..._vm.defaults },false),[_vm._t("default"),(_vm.$attrs.center)?_c('MglMarker',{attrs:{"coordinates":_vm.$attrs.center,"color":_vm.color}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }